export default __webpack_public_path__ + "static/media/verified.5b2d4cc0.svg";